export const save= (userInfo: any) => {

};

export function getOkVeridasQrLiterals(t: any) {
    return {
        titleBanner: t("literals.titleVeridasQR"),
        tripDescription: t("literals.descVeridasQR"),
    }
  }
